<template>
    <div class="fiatradCenter">
        
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/fiatradCenter.vue